/**
 * Presets de orden del listado de licitaciones y cuál de ellos se muestra
 * activo. El orden por defecto es el que aplica el backend cuando la petición
 * no lleva `sortBy` —cierre ascendente, las más próximas primero—, según el
 * spec `ordenamiento-columnas`.
 */
export type OrdenPreset = {
  id: string;
  label: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
};

const ORDEN_POR_DEFECTO: OrdenPreset = {
  id: "cierre",
  label: "Próximas a cerrar",
  sortBy: "fechaCierre",
  sortOrder: "asc",
};

export const ORDEN_PRESETS: OrdenPreset[] = [
  { id: "recientes", label: "Más recientes", sortBy: "fechaPublicacion", sortOrder: "desc" },
  ORDEN_POR_DEFECTO,
  { id: "estado", label: "Estado MP", sortBy: "estadoMP", sortOrder: "asc" },
  { id: "monto", label: "Mayor monto", sortBy: "montoEstimado", sortOrder: "desc" },
  { id: "score", label: "Mayor score IA", sortBy: "scoreIA", sortOrder: "desc" },
];

/**
 * Preset que el listado muestra como activo. Sin orden explícito el backend
 * ordena por defecto, así que el indicador nombra ese orden y no otro.
 */
export function presetDeOrden(
  sortBy: string | undefined,
  sortOrder: "asc" | "desc" | undefined,
): OrdenPreset {
  return (
    ORDEN_PRESETS.find((p) => p.sortBy === sortBy && p.sortOrder === sortOrder) ??
    (sortBy ? { id: "columna", label: "Orden manual" } : ORDEN_POR_DEFECTO)
  );
}
